import { ref } from "vue";
import { Config } from "tf-api-client";
import api from "../api";

const settings = ref<Config.Setting[]>();
let fetchStarted = false;

const fetchSettings = async () => {
  try {
    const response = await api.config.getSettings();
    settings.value = response;
  } catch (error) {
    fetchStarted = false;
    throw error;
  }
};

const updateSettings = async (data: Config.UpdateConfigSettingsPayload) => {
  settings.value = await api.config.updateSettings(data);
};

const getSettingValue = <T extends Config.Setting["value"]>(
  key: Config.SettingKind,
  options?: {
    default?: T;
  },
): T extends undefined ? Config.Setting["value"] | undefined : T => {
  // Defensive: an unexpected (non-array) response must fall back to the
  // defaults instead of crashing every consumer of a setting.
  const list = Array.isArray(settings.value) ? settings.value : [];
  return (list.find((setting) => setting.kind === key)?.value ??
    options?.default) as any;
};

export function useSettings() {
  if (!fetchStarted) {
    fetchStarted = true;
    fetchSettings().catch((_error) => {});
  }

  return {
    getSettingValue,
    settings,
    fetchSettings,
    updateSettings,
  };
}
